import { render } from "./configuratorTeaser.vue?vue&type=template&id=57fdac54"
import script from "./configuratorTeaser.vue?vue&type=script&lang=js"
export * from "./configuratorTeaser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__